import {
    getHeaders,
    getStorage,
    getOptionsOutput,
    getActionFileToPlay,
    getInputFileFont
} from '../../lib/skycity.js'
import axios from 'axios'

export async function getConfig (curFile, outputOptions, iccProfileOption, inputSecondFiles, psActionFile, inputFontFiles) {
    const payload = await getCodePayload(curFile, outputOptions, iccProfileOption, inputSecondFiles, psActionFile, inputFontFiles)
    const config = {
        url: `${process.env.REACT_APP_CONFIG_ENDPOINT_PIE}/psdService/actionJSON`,
        method: 'POST',
        timeout: 180000,
        // timeout: 5000,
        headers: getHeaders(),
        payload: payload,
        body: JSON.stringify(payload)
    }
    return config
}

export async function getConfigLinux (curFile, outputOptions, iccProfileOption, inputSecondFiles, psActionFile, inputFontFiles) {
    const payload = await getCodePayload(curFile, outputOptions, iccProfileOption, inputSecondFiles, psActionFile, inputFontFiles)
    payload.options.costOptimization = true
    const config = {
        url: `${process.env.REACT_APP_CONFIG_ENDPOINT_PIE}/psdService/actionJSON`,
        method: 'POST',
        timeout: 180000,
        // timeout: 5000,
        headers: getHeaders(),
        payload: payload,
        body: JSON.stringify(payload)
    }
    return config
}

async function getCodePayload (curFile, outputOptions, iccProfileOption, inputSecondFiles, psActionFile, inputFontFiles) {
    const url = `${inputSecondFiles[0].path}`
    const response = await axios.get(url)
    const data = response.data
    const codePayload = {
        inputs: [
            {
                href: curFile.path || curFile.href,
                storage: getStorage(curFile)
            }
        ],
        options: {
            actionJSON: data
        },
        outputs: await getOptionsOutput(curFile, outputOptions, iccProfileOption)
    }
    if (inputFontFiles && inputFontFiles.length > 0) {
        codePayload.options.fonts = getInputFileFont(inputFontFiles)
    }
    return codePayload
}
